import { Genders } from "../constants/Genders";
import { PronounForm } from "../constants/PronounForms";

export const getPronoun = (gender: Genders, pronounForm: PronounForm) => {
    const malePronounsMap = new Map<PronounForm, string>();
    malePronounsMap.set(PronounForm.they, "he");
    malePronounsMap.set(PronounForm.their, "his");
    malePronounsMap.set(PronounForm.them, "him");
    malePronounsMap.set(PronounForm.themselves, "himself");
    malePronounsMap.set(PronounForm.theirs, "his");
    malePronounsMap.set(PronounForm.theyAre, "he is");
    malePronounsMap.set(PronounForm.theyHave, "he has");
    malePronounsMap.set(PronounForm.theyDo, "he does");
    malePronounsMap.set(PronounForm.theyGet, "he gets");
    malePronounsMap.set(PronounForm.theyPark, "he parks");
    malePronounsMap.set(PronounForm.theyCook, "he cooks");
    malePronounsMap.set(PronounForm.theyBuy, "he buys");
    malePronounsMap.set(PronounForm.theyHate, "he hates");
    malePronounsMap.set(PronounForm.theyWere, "he was");
    malePronounsMap.set(PronounForm.theyTry, "he tries");
    malePronounsMap.set(PronounForm.theyTrust, "he trusts");
    malePronounsMap.set(PronounForm.theyThink, "he thinks");
    malePronounsMap.set(PronounForm.theyKnow, "he knows");
    malePronounsMap.set(PronounForm.theyNeed, "he needs");
    malePronounsMap.set(PronounForm.theyWalk, "he walks");
    malePronounsMap.set(PronounForm.theyTalk, "he talks");
    malePronounsMap.set(PronounForm.theyHit, "he hits");
    malePronounsMap.set(PronounForm.theyForget, "he forgets");
    malePronounsMap.set(PronounForm.theyLike, "he likes");
    malePronounsMap.set(PronounForm.theyBlow, "he blows");
    malePronounsMap.set(PronounForm.theyAsk, "he asks");

    const femalePronounsMap = new Map<PronounForm, string>();
    femalePronounsMap.set(PronounForm.they, "she");
    femalePronounsMap.set(PronounForm.their, "her");
    femalePronounsMap.set(PronounForm.them, "her");
    femalePronounsMap.set(PronounForm.themselves, "herself");
    femalePronounsMap.set(PronounForm.theirs, "hers");
    femalePronounsMap.set(PronounForm.theyAre, "she is");
    femalePronounsMap.set(PronounForm.theyHave, "she has");
    femalePronounsMap.set(PronounForm.theyDo, "she does");
    femalePronounsMap.set(PronounForm.theyGet, "she gets");
    femalePronounsMap.set(PronounForm.theyPark, "she parks");
    femalePronounsMap.set(PronounForm.theyCook, "she cooks");
    femalePronounsMap.set(PronounForm.theyBuy, "she buys");
    femalePronounsMap.set(PronounForm.theyHate, "she hates");
    femalePronounsMap.set(PronounForm.theyWere, "she was");
    femalePronounsMap.set(PronounForm.theyTry, "she tries");
    femalePronounsMap.set(PronounForm.theyTrust, "she trusts");
    femalePronounsMap.set(PronounForm.theyThink, "she thinks");
    femalePronounsMap.set(PronounForm.theyKnow, "she knows");
    femalePronounsMap.set(PronounForm.theyNeed, "she needs");
    femalePronounsMap.set(PronounForm.theyWalk, "she walks");
    femalePronounsMap.set(PronounForm.theyTalk, "she talks");
    femalePronounsMap.set(PronounForm.theyHit, "she hits");
    femalePronounsMap.set(PronounForm.theyForget, "she forgets");
    femalePronounsMap.set(PronounForm.theyLike, "she likes");
    femalePronounsMap.set(PronounForm.theyBlow, "she blows");
    femalePronounsMap.set(PronounForm.theyAsk, "she asks");

    const otherPronounsMap = new Map<PronounForm, string>();
    otherPronounsMap.set(PronounForm.they, "they");
    otherPronounsMap.set(PronounForm.their, "their");
    otherPronounsMap.set(PronounForm.them, "them");
    otherPronounsMap.set(PronounForm.themselves, "themselves");
    otherPronounsMap.set(PronounForm.theirs, "theirs");
    otherPronounsMap.set(PronounForm.theyAre, "they are");
    otherPronounsMap.set(PronounForm.theyHave, "they have");
    otherPronounsMap.set(PronounForm.theyDo, "they do");
    otherPronounsMap.set(PronounForm.theyGet, "they get");
    otherPronounsMap.set(PronounForm.theyPark, "they park");
    otherPronounsMap.set(PronounForm.theyCook, "they cook");
    otherPronounsMap.set(PronounForm.theyBuy, "they buy");
    otherPronounsMap.set(PronounForm.theyHate, "they hate");
    otherPronounsMap.set(PronounForm.theyWere, "they were");
    otherPronounsMap.set(PronounForm.theyTry, "they try");
    otherPronounsMap.set(PronounForm.theyTrust, "they trust");
    otherPronounsMap.set(PronounForm.theyThink, "they think");
    otherPronounsMap.set(PronounForm.theyKnow, "they know");
    otherPronounsMap.set(PronounForm.theyNeed, "they need");
    otherPronounsMap.set(PronounForm.theyWalk, "they walk");
    otherPronounsMap.set(PronounForm.theyTalk, "they talk");
    otherPronounsMap.set(PronounForm.theyHit, "they hit");
    otherPronounsMap.set(PronounForm.theyForget, "they forget");
    otherPronounsMap.set(PronounForm.theyLike, "they like");
    otherPronounsMap.set(PronounForm.theyBlow, "they blow");
    otherPronounsMap.set(PronounForm.theyAsk, "they ask");

    if (gender === Genders.male) {
        return malePronounsMap.get(pronounForm) ?? "";
    }

    if (gender === Genders.female) {
        return femalePronounsMap.get(pronounForm) ?? "";
    }

    if (gender === Genders.other) {
        return otherPronounsMap.get(pronounForm) ?? "";
    }

    return "";
}

export const replacePronouns = (cardText: string, criminalGender: Genders) => {
    let text = cardText;
    text = text.split("[1]").join(getPronoun(criminalGender, PronounForm.they)); // replace [1]
    text = text.split("[2]").join(getPronoun(criminalGender, PronounForm.their)); // replace [2]
    text = text.split("[3]").join(getPronoun(criminalGender, PronounForm.them)); // replace [3]
    text = text.split("[4]").join(getPronoun(criminalGender, PronounForm.themselves)); // replace [4]
    text = text.split("[5]").join(getPronoun(criminalGender, PronounForm.theirs)); // replace [5]
    text = text.split("[6]").join(getPronoun(criminalGender, PronounForm.theyAre)); // replace [6]
    text = text.split("[7]").join(getPronoun(criminalGender, PronounForm.theyHave)); // replace [7]
    text = text.split("[8]").join(getPronoun(criminalGender, PronounForm.theyDo)); // replace [8]
    text = text.split("[9]").join(getPronoun(criminalGender, PronounForm.theyGet)); // replace [9]
    text = text.split("[10]").join(getPronoun(criminalGender, PronounForm.theyPark)); // replace [10]
    text = text.split("[11]").join(getPronoun(criminalGender, PronounForm.theyCook)); // replace [11]
    text = text.split("[12]").join(getPronoun(criminalGender, PronounForm.theyBuy)); // replace [12]
    text = text.split("[13]").join(getPronoun(criminalGender, PronounForm.theyHate)); // replace [13]
    text = text.split("[14]").join(getPronoun(criminalGender, PronounForm.theyWere)); // replace [14]
    text = text.split("[15]").join(getPronoun(criminalGender, PronounForm.theyTry)); // replace [15]
    text = text.split("[16]").join(getPronoun(criminalGender, PronounForm.theyTrust)); // replace [16]
    text = text.split("[17]").join(getPronoun(criminalGender, PronounForm.theyThink)); // replace [17]
    text = text.split("[18]").join(getPronoun(criminalGender, PronounForm.theyKnow)); // replace [18]
    text = text.split("[19]").join(getPronoun(criminalGender, PronounForm.theyNeed)); // replace [19]
    text = text.split("[20]").join(getPronoun(criminalGender, PronounForm.theyWalk)); // replace [20]
    text = text.split("[21]").join(getPronoun(criminalGender, PronounForm.theyWalk)); // replace [21]
    text = text.split("[22]").join(getPronoun(criminalGender, PronounForm.theyHit)); // replace [22]
    text = text.split("[23]").join(getPronoun(criminalGender, PronounForm.theyForget)); // replace [23]
    text = text.split("[24]").join(getPronoun(criminalGender, PronounForm.theyLike)); // replace [24]
    text = text.split("[25]").join(getPronoun(criminalGender, PronounForm.theyBlow)); // replace [25]
    text = text.split("[26]").join(getPronoun(criminalGender, PronounForm.theyAsk)); // replace [26]
    return text;
}